import { ITranslations } from 'types/common';
import { PolygonsStatusCellTransFields } from './types';
import en from 'translations/en/polygonsStatusCell.json';
import pl from 'translations/pl/polygonsStatusCell.json';
import sl from 'translations/sl/polygonsStatusCell.json';

export const polygonsStatusCellTranslations: ITranslations<PolygonsStatusCellTransFields> = {
  name: 'polygonsStatusCell',
  en,
  pl,
  sl,
};
